/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Select_Next_EventInputs */

const en_shortcut_keys_name_select_next_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Next Event`)
};

const fr_shortcut_keys_name_select_next_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner l'evenement suivant`)
};

const de_shortcut_keys_name_select_next_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächstes Ereignis auswählen`)
};

const it_shortcut_keys_name_select_next_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona evento successivo`)
};

const ru_shortcut_keys_name_select_next_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите следующее событие`)
};

const es_shortcut_keys_name_select_next_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar próximo evento`)
};

const zh_cn2_shortcut_keys_name_select_next_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择下一个活动`)
};

const ja_shortcut_keys_name_select_next_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベントを選択`)
};

const hi_shortcut_keys_name_select_next_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला कार्यक्रम चुनें`)
};

const pt_pt2_shortcut_keys_name_select_next_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o próximo evento`)
};

/**
* | output |
* | --- |
* | "Select Next Event" |
*
* @param {Shortcut_Keys_Name_Select_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_select_next_event = /** @type {((inputs?: Shortcut_Keys_Name_Select_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Select_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_select_next_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_select_next_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_select_next_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_select_next_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_select_next_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_select_next_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_select_next_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_select_next_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_select_next_event(inputs)
	return en_shortcut_keys_name_select_next_event(inputs)
});